export const intro = {
  name: 'Matthew Tran',
  role: 'Software Engineer',
  tagline: {
    line1: 'Building memorable experiences.',
    line2: 'Not just another product.',
  },
  location: 'Toronto, ON',
  year: new Date().getFullYear(),
};
